import { render, staticRenderFns } from "./classEndReminder.vue?vue&type=template&id=4b33de22&scoped=true"
import script from "./classEndReminder.vue?vue&type=script&lang=js"
export * from "./classEndReminder.vue?vue&type=script&lang=js"
import style0 from "./classEndReminder.vue?vue&type=style&index=0&id=4b33de22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33de22",
  null
  
)

export default component.exports